import React, {Fragment} from "react";
import image from '../../../images/situation/luikhoogte/luikhoogte.jpg'

export default function Hoogte(props) {
    return <Fragment>
        <div className="addtextMore">
            Hier kunt u invullen wat de hoogte van de luiken is, in milimeters.<br/>
            <br/>
            Voorbeeld:
            <br/>
            Als uw luik 150 cm hoog is, voert u 1500 in als waarde.
        </div>
        <img className="explainImage" src={image} alt=""/>
    </Fragment>;
}